import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { staticText } from '../../../static-text';
import { Dispatcher } from '../../../types/booking-request';

export function numberOfPersonsSelect(
	startOfStay: Date | null,
	numberOfPersons: number,
	maxPersons: number,
	dispatch: Dispatcher,
	assetUrl: string,
	numberOfPersonsFailure?: Failure
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( !( e.target instanceof HTMLSelectElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLSelectElement' );
		}

		const value = parseInt( e.target.value, 10 );
		if ( isNaN( value ) ) {
			dispatch( {
				type: 'UPDATE_NUMBER_OF_PERSONS_FAILURE',
				numberOfPersonsFailure: Failure.from( staticText.numberOfPersonsNotANumberFailureMessage ),
			} );

			return;
		}

		if (
			1 > value ||
			maxPersons < value
		) {
			dispatch( {
				type: 'UPDATE_NUMBER_OF_PERSONS_FAILURE',
				numberOfPersonsFailure: Failure.from( staticText.numberOfPersonsUnknownValueFailureMessage( maxPersons ) ),
			} );

			return;
		}

		dispatch( {
			type: 'UPDATE_NUMBER_OF_PERSONS',
			numberOfPersons: value,
		} );
	};

	const options = [];
	for ( let i = 1; i <= maxPersons; i++ ) {
		options.push(
			html`
				<option
					value=${i}
					?selected=${i === numberOfPersons}
				>
					${i}
				</option>
			`
		);
	}

	const classes = {
		'has-error': numberOfPersonsFailure !== undefined,
	};

	let failure = html``;
	if ( Failure.isFailure( numberOfPersonsFailure ) ) {
		failure = html`
			<p class="form__field-validation-error theme-color-error">
				<img alt="" class="form__field-validation-error__icon" src="${assetUrl}/assets/images/alert-circle.svg">
				${numberOfPersonsFailure.toString}
			</p>
		`;
	}

	return html`
		<div class="form__row ${classMap( classes )}">
			<div class="form__label-container type-d">
				<label class="form__label" for="number-of-persons">
					${staticText.numberOfPersons}
				</label>
			</div>

			<select
				.disabled=${!startOfStay}
				@change=${changeHandler}
				class="form__select"
				id="number-of-persons"
				name="number-of-persons"
			>
				${options}
			</select>

			${failure}
		</div>
	`;
}
